import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import { HeadingTypeEnum } from 'common/enums/HeadingTypeEnum'
import { HeadlineInterface } from 'common/types/entities/HeadlineInterface'
import {
  headingFontSize,
  mobileHeadingFontSize,
} from 'src/shared/entities/headline/heading-typography'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export function createHeadline(
  parentId: string,
  text: string,
  masterBlockId?: MasterBlockIdType,
): HeadlineInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.Headline, parentId, masterBlockId),
    content: `<h3>${text}</h3>`,
    ...headingFontSize[HeadingTypeEnum.HeaderTwo],
    mobileFontSize: mobileHeadingFontSize[HeadingTypeEnum.HeaderTwo].fontSize,
    mobileLineHeight:
      mobileHeadingFontSize[HeadingTypeEnum.HeaderTwo].lineHeight,
    margin: { marginTop: 15, marginRight: 0, marginBottom: 15, marginLeft: 0 },
    padding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    mobilePadding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
  }
}
